<template>
  <wrap-container>
    <help-title title="Robo o Perdida de tarjeta" />

    <help-list-container>
      <help-list-item tituloLista="¿Cómo tengo que denunciar el robo?">
        Para denunciar el robo o extravío de tus tarjetas comunicate a los
        siguientes números:<br />
        <strong>Tarjeta de Débito</strong> <br />
        - Centro de Atención Banelco: (011) 4320-2500. <br />
        - Si estás en el exterior:<br />
        <ol>
          Estados Unidos y Canadá: 1-0800-396-9665 (sin cargo).<br />
          Para Resto del Mundo: (303) 967- 1098 (por cobro revertido).
        </ol>
        <br />
        <strong>Tarjeta de Crédito Visa</strong><br />
        - Centro de Denuncias Visa: (011) 4379-3333 o 0810-666-3368 para el
        interior del país. <br />
        - Si estás en el exterior: <br />
        <ol>
          Estados Unidos: 1877-233-8472101-6985
          <br />
          Para Resto del Mundo: 1 (303) 967-1098 (por cobro revertido).
        </ol>
        <br />

        <strong>Tarjeta de Crédito MasterCard</strong><br />
        - Centro de Atención Telefónica a Socios: 4340-5700 o 0810-999-5700 para
        el interior del país. <br />
        Si estás en el exterior: (5411) 4340-5656, por cobro revertido.
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad. También podes acercarte a tu Sucursal.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
